<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted () {
    $(function () {
      if ($(document.body).width() > 892) {
        var t = window.devicePixelRatio
        var z = 1 / t;
        var zoom = z <= 0.75 ? 0.75 : z
        // 火狐
        $('.container2').css('-moz-transform', "scale(" + zoom + ")")
        // 谷歌
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          console.log('It is IE brower')
        } else {
          $(document.body).css('zoom', zoom)
        }
      }
    })
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue